import { Token } from '@/entities/auth/token';
import { TokenData } from './codec';

export function transform(data: TokenData): Token {
  return {
    expiresIn: data.expiresIn || undefined,
    token: data.token,
    tokenType: data.tokenType,
  };
}
